import React from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import { useMutation, useQuery, useQueryClient } from 'react-query';
import AppLayout from '../components/AppLayout';
import api from '../services/api';
import { toast } from 'react-toastify';
import { routes } from '../lib/routes';

const BLOQUEADO = ['cidadao', 'empresa'];

export default function TecnicoVistorias() {
  const navigate = useNavigate();
  const queryClient = useQueryClient();
  const { data: user } = useQuery('me', () => api.get('/usuarios/me').then((r) => r.data), { retry: false });
  const { data: protocolos = [] } = useQuery('protocolos', () => api.get('/protocolos').then((r) => r.data));
  const { data: vistorias = [], isLoading } = useQuery('vistorias', () => api.get('/vistorias').then((r) => r.data));

  const agendar = useMutation(
    (protocoloId) =>
      api.post('/vistorias', { protocolo_id: protocoloId, data_agendada: new Date().toISOString() }),
    {
      onSuccess: () => {
        queryClient.invalidateQueries('vistorias');
        toast.success('Vistoria agendada.');
      },
      onError: (err) => toast.error(err.response?.data?.error || 'Nao foi possivel agendar.'),
    }
  );

  if (user && BLOQUEADO.includes(user.tipo)) {
    return <Navigate to={routes.dashboard} replace />;
  }

  return (
    <AppLayout title="Vistorias" subtitle="Agendamento e acompanhamento.">
      <div className="panel mb-4">
        <h2 className="text-lg font-semibold mb-4">Agendar vistoria</h2>
        <p className="text-sm text-[var(--sispro-muted)] mb-4">Selecione um protocolo para criar um agendamento rapido.</p>
        <div className="space-y-3">
          {protocolos.slice(0, 15).map((p) => (
            <div key={p.id} className="p-3 border border-[var(--sispro-border)] rounded-lg flex flex-wrap justify-between items-center gap-2">
              <div>
                <p className="font-mono text-sm font-semibold">{p.numero}</p>
                <p className="text-sm text-[var(--sispro-muted)]">{p.tipo}</p>
              </div>
              <button type="button" className="sispro-btn sispro-btn--primary sispro-btn--sm" onClick={() => agendar.mutate(p.id)} disabled={agendar.isLoading}>
                Agendar
              </button>
            </div>
          ))}
          {!protocolos.length ? <p className="sispro-empty">Nenhum protocolo disponivel.</p> : null}
        </div>
      </div>
      <div className="panel overflow-auto">
        <h2 className="text-lg font-semibold mb-4">Vistorias recentes</h2>
        {isLoading ? <p className="sispro-empty">Carregando...</p> : null}
        {!isLoading && !vistorias.length ? <p className="sispro-empty">Nenhuma vistoria registrada.</p> : null}
        {vistorias.length ? (
          <table className="w-full min-w-[640px]">
            <thead className="bg-gray-100">
              <tr>
                <th className="p-3 text-left">Protocolo</th>
                <th className="p-3 text-left">Status</th>
                <th className="p-3 text-left">Agendada</th>
                <th className="p-3 text-left">Acoes</th>
              </tr>
            </thead>
            <tbody>
              {vistorias.map((v) => (
                <tr key={v.id} className="border-t">
                  <td className="p-3 font-mono text-sm">{v.protocolo_numero || '—'}</td>
                  <td className="p-3 capitalize">{v.status}</td>
                  <td className="p-3 text-sm">{v.data_agendada ? new Date(v.data_agendada).toLocaleString('pt-BR') : '—'}</td>
                  <td className="p-3">
                    {v.protocolo_id ? (
                      <button
                        type="button"
                        className="sispro-btn sispro-btn--secondary sispro-btn--sm"
                        onClick={() => navigate(routes.protocolo(v.protocolo_id))}
                      >
                        Abrir protocolo
                      </button>
                    ) : (
                      '—'
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : null}
      </div>
    </AppLayout>
  );
}
